import { Kind, Hint, ReadonlyKind, OptionalKind } from '../symbols/index.mjs';
